export default {
  svg: '',
  loading: true,
};
